import Swal from "sweetalert2";

export default function warnDomains(selector, domains) {
	const element = document.querySelector(selector);
	if (!element) {
		return;
	}

	element.addEventListener("change", () => {
		const filtered = domains.filter(
			(domain) => element.value.indexOf(`@${domain}`) > -1,
		);
		for (const domain of filtered) {
			Swal.fire(
				"Hinweis zur E-Mail-Zustellung",
				`
          Bei der Zustellung von E-Mails an ${domain} ist vermehrt gemeldet worden, dass die E-Mails im Spam-Ordner gelandet seien.
          Wenn Sie keine E-Mail nach der Registrierung erhalten, prüfen Sie bitte Ihren Spam-Ordner. Falls auch dort keine E-Mail angekommen ist, melden Sie sich bitte bei uns.
          Um dies im Vorfeld zu vermeiden, können Sie eine andere E-Mail-Adresse eines anderen Anbieters verwenden.
        `,
			);
		}
	});
}
